import { z } from 'zod';
/** Verejny klic VAPID pro pushManager.subscribe. */
export const PushKeyResponseSchema = z.object({ publicKey: z.string().min(20) });
/** Odber z PushSubscription.toJSON() — jen pole, ktera server potrebuje. */
export const PushSubscriptionInputSchema = z.object({
    endpoint: z.url().max(1000),
    keys: z.object({
        p256dh: z.string().min(10).max(200),
        auth: z.string().min(8).max(100),
    }),
});
export const PushTestResponseSchema = z.object({ ok: z.literal(true), sent: z.number().int().nonnegative() });
//# sourceMappingURL=push.js.map